import { render, staticRenderFns } from "./DetailsTarif.vue?vue&type=template&id=28871c1a&scoped=true&"
import script from "./DetailsTarif.vue?vue&type=script&lang=js&"
export * from "./DetailsTarif.vue?vue&type=script&lang=js&"
import style0 from "./DetailsTarif.vue?vue&type=style&index=0&id=28871c1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28871c1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28871c1a')) {
      api.createRecord('28871c1a', component.options)
    } else {
      api.reload('28871c1a', component.options)
    }
    module.hot.accept("./DetailsTarif.vue?vue&type=template&id=28871c1a&scoped=true&", function () {
      api.rerender('28871c1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Divers/DetailsTarif.vue"
export default component.exports